<template>
   <div id="app" :data-theme="theme">
      <div v-if="isUserLoggedIn && showMenu && getConfig">
         <my-menu :key="menuReloadKey"></my-menu>
      </div>

      <router-view
         :class="paddingClass"
         class="main-router-view"
         v-if="getConfig && (showMainView || !isUserLoggedIn)"
      ></router-view>

      <loading :active="getLoading"></loading>
      <div v-if="showMenu">
         <div class="right-border"></div>
         <div class="footer"></div>
      </div>
      <!-- <div v-if="!showMenu && isUserLoggedIn" class="left-border"></div> -->
   </div>
</template>

<script>
import Menu from "./components/reusable/menu/Menu";
import { mapGetters } from "vuex";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
   name: "app",
   components: {
      myMenu: Menu,
      Loading,
   },
   computed: {
      ...mapGetters([
         "isUserLoggedIn",
         "getError",
         "getConfig",
         "getMenu",
         "getLoading",
         "theme",
         "getRolesTableArray",
         "language",
         "getUser"
      ]),
   },
   methods: {
      errorMoreClick() {
         //console.log("ERROR");
         this.$notify({
            title:  this.$t("general.errorMessages.details"),
            message: this.getError,
            duration: 0,
            onClose: () => this.$store.commit("setError", null),
         });
      },
      setLanguage() {
         const savedConnection = this.$localStorage.get("wa-connection");
         if (!savedConnection) return;
         const parsedConnection = JSON.parse(savedConnection);
         if (parsedConnection.language) {
            this.$i18n.locale =
               parsedConnection.language === "uk"
                  ? "ua"
                  : parsedConnection.language;
         } else if (this.language) {
            this.$i18n.locale = this.language === "uk" ? "ua" : this.language;
         }
      },
   },
   created() {
      this.$store.commit("setLoading", true);
      this.setLanguage();
      this.$store
         .dispatch("getConfig")
         .then(() => {
            // if (this.toLink !== null && this.toLink !== "homeLink") {
            if (this.toLink !== "homeLink") {
               let menuWidth = this.getMenu ? this.getMenu : "full";
               this.paddingClass = this.isUserLoggedIn ? menuWidth : "none";
            } else {
               //если идем на страницу домашнюю
               this.paddingClass = "none";
            }
            if (this.isUserLoggedIn) return this.$store.dispatch("getRoleId");
         })
         .then(() => {
            // console.log("appvue", this.getUser.roletype);
            return this.$store.dispatch("getServers", this.getUser.roletype === "1" || +this.getUser.roleid > 1);
         })
         .then(() => {
            // console.log("getAllTypes");
            return this.$store.dispatch("getAllTypes");
         })
         .then(() => {
            this.$store.commit("setLoading", false);
            this.showMainView = true;
         })
         .catch(() => {
            this.$store.commit("setLoading", false);
            this.showMainView = true;
         });
      // await this.$store.dispatch("getServers");
      // this.withPadding = this.isUserLoggedIn;
   },
   watch: {
      getMenu() {
         this.paddingClass = this.getMenu;
         this.menuReloadKey++;
      },
      $route(to, from) {
         let menuWidth = !!this.getMenu ? this.getMenu : "full";
         this.toLink = to.name;
         //  console.log("route");
         //  this.setLanguage();
         if (this.isUserLoggedIn) {
            if (to.name === "homeLink") {
               // //console.log("in if");
               this.showMenu = false;
               this.paddingClass = "none";
            } else {
               this.showMenu = true;
               this.paddingClass = menuWidth;
            }
         } else {
            this.showMenu = false;
            this.paddingClass = "none";
         }
         // //console.log(this.paddingClass);
      },
      getError() {
         if (!!this.getError) {
            console.error(this.getError);
            this.$store.commit("setLoading", false);
            //console.log(this.getError);
            let error = this.getError;
            const h = this.$createElement;
            if (typeof error === "string" && error.includes("{[")) {
               // если ошибка пришла с внутренним форматированием
               // {[^{^}]+}
               // console.log("MATCH: ", error);
               error = error.match(/{\[(?:(?!{\[|\]}).)*\]}/);
               // console.log("MATCH: ", error[0]);
               error = error[0].replace("{[", "");
               error = error.replace("]}", "");
               // console.log("MATCH: ", error);
               this.$msgbox({
                  title: this.$t("general.errorMessages.error"),
                  message: h("div", null, [
                     h("div", error),
                     h(
                        "el-button",
                        {
                           on: {
                              click: this.errorMoreClick,
                           },
                           style: {},
                        },
                        this.$t("general.errorMessages.details")
                     ),
                  ]),
               })
                  .then(() => {
                     this.$store.commit("setError", null);
                  })
                  .catch(() => {
                     this.$store.commit("setError", null);
                  });
            } else {
               this.$msgbox({
                  title: this.$t("general.errorMessages.error"),
                  message: this.getError,
               })
                  .then(() => {
                     this.$store.commit("setError", null);
                  })
                  .catch(() => {
                     this.$store.commit("setError", null);
                  });
            }
         }
      },
      isUserLoggedIn() {
         // this.withPadding = this.isUserLoggedIn;
         // this.paddingClass = this.isUserLoggedIn ? "full" : "none";
         let menuWidth = !!this.getMenu ? this.getMenu : "full";
         if (this.toLink !== null && this.toLink !== "homeLink") {
            this.paddingClass = this.isUserLoggedIn ? menuWidth : "none";
         } else {
            //если идем на страницу домашнюю
            this.paddingClass = "none";
         }
         this.setLanguage();
         if (this.isUserLoggedIn) {
            this.$store.commit("setLoading", true);
            this.$store
               .dispatch("getAllTypes")
               .then(() => {
                  this.$store.commit("setLoading", false);
                  this.showMainView = true;
               })
               .catch(() => {
                  this.$store.commit("setLoading", false);
                  this.showMainView = true;
               });
         }
      },
   },
   data() {
      return {
         paddingClass: "none",
         // ready: false,
         showMenu: true,
         toLink: null,
         showMainView: false,
         menuReloadKey: 0,
      };
   },
};
</script>

<style lang="scss">
@import "assets/variables.css";
@import "assets/font_import.css";
// @import "assets/element_ui_overwrite.css";

@import "assets/ag-grid-vars-override.scss";

@import "../node_modules/ag-grid-community/src/styles/ag-theme-balham/sass/legacy/ag-theme-balham-v22-compat.scss";
@import "../node_modules/ag-grid-community/src/styles/ag-grid.scss";

* {
   margin: 0;
   padding: 0;
   font-family: "Montserrat", sans-serif;
}

.el-button.left span {
   margin-left: 5px;
}
.ag-theme-balham {
   font-weight: 500;
}
.ag-row.failed-status {
   color: darkred !important;
}
.center-column {
   text-align: center;
}
.ag-theme-balham .ag-header-cell-label {
   font-weight: 600;
   font-family: "Open Sans", sans-serif;
   display: flex !important;
   padding-bottom: 0.1em;
}
.ag-theme-balham .ag-header-cell-label > span {
   /*Сам текст внутри*/
   float: none !important;
}
.ag-theme-balham .ag-status-error{
   color: darkred !important;
}

.ag-theme-balham .ag-status-null{
   color: darkgoldenrod !important;
}
// for hardware info table
.el-table .error-row{
  color: darkred !important;
}
.el-table .warning-row{
  color: darkgoldenrod;
}
.el-card.box-card .el-card__header {
   background-color: var(--active-color) !important;
   font-weight: 500;
}
/*Для выбора сервера/приложения и тд на основных страницах*/
.settings-line {
   display: flex;
   background: var(--main-background);
   justify-content: flex-start;
   flex-direction: row;
   padding-right: 10px;
   height: 50px;
   font-size: 0.9em;
   font-weight: 500;
   // margin-bottom: -10px;
}

.buttons-grid {
   background: var(--main-background);
   height: 50px;
   display: flex;
   width: 100%;
}
.buttons-grid.between {
   justify-content: space-between;
}
.buttons-grid .el-tooltip .el-button {
   transform: scale(0.8);
   margin-top: 5px;
}
.buttons-grid .el-dropdown {
   transform: scale(0.9);
   margin-top: 6px;
}
.text-buttons {
   transform: scale(0.8);
   margin-top: 5px;
}

.buttons-bottom {
   display: flex;
   justify-content: space-between;
}

.grid-container-full {
   height: calc(100vh - (50px + var(--header-height) + 5px));
   width: 100%;
   overflow-y: auto;
   background: var(--main-background);
   padding-left: 5px;
}
.grid-container-smaller {
   height: calc(100vh - (100px + var(--header-height) + 5px));
   width: 100%;
   overflow-y: auto;
   background: var(--main-background);
   padding-left: 5px;
}

.off-bckgr-container-full {
   // height: calc(100vh - (var(--header-height) + 5px));
   height: calc(100vh - (var(--header-height) + 20px));
   overflow-y: auto;
   background: var(--main-background);
}

.settings-element {
   display: flex;
   flex-direction: row;
   margin: 5px 10px;
}

.settings-element select {
   height: 40px;
   width: 210px;
   border-radius: 2px;
   border: 1px solid lightgrey;
}

.settings-element .el-select {
   margin-top: 3px;
}

.settings-element label {
   margin: 12px 12px 12px;
}

.input {
   height: 20px;
}
.main-menu {
   z-index: 999;
}
.bottom-buttons {
   margin-top: 10px;
   display: flex;
   justify-content: space-between;
}
.main-form-scroll {
   overflow-y: auto;
   height: 62vh;
   scrollbar-color: grey lightgrey;
   scrollbar-width: auto;
   margin-right: -20px;
   padding-right: 10px;
}

.main-form-scroll::-webkit-scrollbar {
   width: 8px;
   height: 8px;
}

.main-form-scroll::-webkit-scrollbar-track {
   background-color: lightgrey;
}

.main-form-scroll::-webkit-scrollbar-thumb {
   background-color: grey;
}
.more-info__inner {
   height: 70vh;
   overflow: auto;
   scrollbar-color: grey lightgrey;
   scrollbar-width: auto;
}

.more-info__inner::-webkit-scrollbar {
   width: 10px;
   height: 10px;
}

.more-info__inner::-webkit-scrollbar-track {
   background-color: lightgrey;
}

.more-info__inner::-webkit-scrollbar-thumb {
   background-color: grey;
}
.mono-text{
  font-family: "Roboto Mono", monospace !important;
}
.el-dialog{
   margin-top: 40px !important;
}

.el-select {
   width: 100%;
}
.cron-radio-container .el-radio.cron-radio .el-radio__label{
  width: 100%;
}
.main-list {
   margin-top: 60px;
}
.main-list li {
   padding-left: 30px;
   margin: 6px 0;
}
ul {
   list-style: none;
}
.el-alert {
   z-index: 0 !important;
}
// span {
//   display: var(--display);
//   padding-right: var(--span-padding);
// }

.el-radio.cron-radio span.el-radio__inner {
   margin-top: 16px !important;
}

.el-dialog .server-info{
   margin-top: 20px;
   padding-top: 20px;
   // border-top: 4px solid lightgrey;
}
.el-dialog .server-info:first-of-type{
   margin-top: 0px;
   padding-top: 0px;
   border-top: none;
}
.el-dialog .server-info .server-name{
   font-size: 1.2em;
   margin-left: -17px;
   font-weight: 600;
   margin-bottom: 10px;
}
.el-dialog .server-info .server-name.error{
   color: darkred;
}
.el-dialog .server-info .server-name.warning{
   color: darkgoldenrod;
}
.el-dialog .server-info .server-name:hover{
   font-weight: 700;
   cursor: pointer;
   text-decoration: underline;
}
.el-dialog .server-info .error{
   font-weight: 600;
   color: darkred;
}

.el-dialog .caption{
   margin-top: 20px;
   margin-bottom: 10px;
   font-style: italic;
}
.el-dialog .caption .command{
   font-style: normal;
   font-weight: 600;
}
</style>

<style scoped>
.small {
   padding-left: var(--nav-left-small);
}
.full {
   padding-left: var(--nav-left-width);
}
.none {
   padding-left: 0px;
}

.main-router-view {
   padding-top: var(--header-height);
   padding-bottom: 5px;
   padding-right: 5px;
   overflow-y: auto;
   min-height: calc(100vh - var(--header-height) - 5px);
   background-color: var(--main-background);
}
#app {
   position: relative;
}
.footer {
   width: 100%;
   height: 5px;
   z-index: 30;
   position: absolute;
   left: 0;
   bottom: 0;
   background: var(--main-background);
}
.right-border {
   height: 100%;
   position: absolute;
   top: 0;
   right: 0;
   width: 5px;
   background: var(--main-background);
}
.left-border {
   height: 100%;
   position: absolute;
   top: 0;
   left: 0;
   width: 5px;
   background: var(--main-background);
}
</style>